var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00006 0.37146C9.18467 0.37146 11.7693 2.95608 11.7693 6.14069C11.7693 9.32531 9.18467 11.9099 6.00006 11.9099C2.81544 11.9099 0.230826 9.32531 0.230826 6.14069C0.230826 2.95608 2.81544 0.37146 6.00006 0.37146ZM5.44621 9.02531H6.5539V8.04684V5.81761H5.44621V9.02531ZM6.00006 4.74684C6.47083 4.74684 6.8539 4.36377 6.8539 3.893C6.8539 3.42223 6.47083 3.03915 6.00006 3.03915C5.52929 3.03915 5.14621 3.42223 5.14621 3.893C5.14621 4.36377 5.52929 4.74684 6.00006 4.74684Z",
    fill: "#848484",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "matrix(-1 0 0 1 12 0.0946045)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.dbd8bc2184190488bedabc2efc3e3fca.svg";
export { ForwardRef as ReactComponent };